module.exports = __webpack_public_path__ + "img/rental-selected.20eb174f.svg";